var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72907 0.924239C4.76285 0.958035 4.91041 1.08433 5.0313 1.20262C5.7913 1.89278 7.03574 3.69558 7.4153 4.63833C7.47663 4.78152 7.60552 5.1435 7.61441 5.33739C7.61441 5.52238 7.57174 5.69937 7.48463 5.86836C7.36285 6.08003 7.1748 6.24568 6.94952 6.33973C6.79307 6.39932 6.3273 6.49093 6.31841 6.49093C5.80819 6.58431 4.97974 6.63501 4.0633 6.63501C3.19041 6.63501 2.39485 6.58431 1.87663 6.50783C1.86863 6.49893 1.28996 6.40733 1.09085 6.30594C0.916413 6.21934 0.76925 6.08624 0.665579 5.92131C0.561907 5.75638 0.505751 5.56601 0.503296 5.37119V5.33739C0.512185 5.0848 0.737074 4.55473 0.745074 4.55473C1.12552 3.66089 2.30952 1.8999 3.0953 1.19194C3.0953 1.19194 3.29796 0.993611 3.42418 0.90734C3.60552 0.771264 3.82952 0.704559 4.05441 0.704559C4.30507 0.704559 4.53885 0.781047 4.72907 0.924239Z",
    fill: "#01BC8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.ec65f91d91b6d59d42cdb02a458a6175.svg";
export { ForwardRef as ReactComponent };